export default __webpack_public_path__ + "static/media/hon_weng_chong.a3a98f16.jpg";